<tax-modal-header>
  {{ 'account_payment.invoice.number' | translate }} {{ invoice?.invoiceId }}
</tax-modal-header>

<tax-modal-content>
  <div class="invoice-detail">
    <div class="item__title" translate>account_payment.modal.date</div>
    <div class="item__value">{{ invoice?.invoiceDate | dateFormat: 'INVCDate' | async }}</div>
    <div class="item__title" translate>account_payment.modal.services</div>
    <!--TODO: fix $any-->
    <div class="item__value">
      {{ invoice?.invoicesData && $any(invoice?.invoicesData)[0]?.tariffName }}
    </div>
    <div class="item__title" translate>account_payment.modal.quantity</div>
    <!--TODO: fix $any-->
    <div class="item__value">
      {{ invoice?.invoicesData && $any(invoice?.invoicesData)[0]?.serviceCount }}
    </div>
    <div class="item__title" translate>account_payment.modal.period</div>
    <div class="item__value">{{ invoice?.calcPeriod }}</div>
    <div class="item__title" translate>account_payment.modal.mark</div>
    <div class="item__value">Платёж</div>
    <div class="item__title" translate>account_payment.modal.tax</div>
    <div class="item__value">{{ invoice?.amountTax | kzCurrency }}</div>
    <div class="item__title" translate>account_payment.modal.total</div>
    <div class="item__value">{{ invoice?.amount | kzCurrency }}</div>
  </div>
</tax-modal-content>
